import fetch from "cross-fetch";
import { encodeParameters } from "@utils/http-util";
import { Logger } from "@utils/logger";

export type SendEmailPinParamsType = {
    attribute: number;
    method: string;
    emailAddress: string;
    firstName: string;
    emailAddressId: number;
    firstNameId: string;
    asi: string;
    url: string;
    language: string;
};

export const sendEmailPIN = (queryParams: SendEmailPinParamsType) => {
    // https://test1.iddataweb.com/test-axn-aws/axn/PIN/sendPIN.max?asi=6e3333fc-bfab-47c0-98ed-d2ef148609ec&attribute=10004&method=EMAIL&emailAddress=&firstName=&emailAddressId=62598&firstNameId=&_=1554320382144
    const params = {
        asi: queryParams.asi || "",
        attribute: queryParams.attribute || "",
        method: queryParams.method || "EMAIL",
        emailAddress: queryParams.emailAddress || "",
        emailAddressId: queryParams.emailAddressId || "",
        firstName: queryParams.firstName || "",
        firstNameId: queryParams.firstNameId || "",
        language: queryParams.language
    };

    const url = `${queryParams.url}?${encodeParameters(params)}&cb=${new Date().getTime()}`;
    Logger.info('Sending email PIN request: ' + url);

    const request = {
        method: "GET"
    };

    return fetch(url, request);
};